import styled from 'styled-components';
import { Box } from './Box';
import {
  WithFlexboxProps,
  withFlexbox,
} from 'style-utils/withStyledProps/withFlexboxProps';

const Flex = styled(Box)<WithFlexboxProps>`
  display: ${(props) => props.d || 'flex'};
  ${withFlexbox}
`;

Flex.displayName = 'Flex';
export default Flex;
